import { useNavigate } from "react-router-dom"
import "../styles/portal/PortalHome.css"
import Botao from "../utils/Botao";
import { signOut } from "../aws/Authentication";
import { PortalContext } from "../Portal";
import { useContext, useEffect } from "react";
import { getUserDevicesAPI } from "../aws/Api";

function PortalHome() {
    const { user, setDevices } = useContext(PortalContext);
    const navigate = useNavigate();
    const estiloBotoes = {width: "160px", height: "100px"};

    const handleOnClickLogout = () => {
        // console.log("Clicou logout");
        signOut().then((data) => {
            // console.log(data);
            navigate("/");
        })
        .catch((err) => {
            // console.log(err.message);
            // setErrorMessage(err.message);
            // setAlertVisibility(true);
        });
    }

    

    useEffect(() => {
        if(!user) {
            navigate("/portal");
            return;
        }
        getUserDevicesAPI(user.attributes.email)
        .then(res => {
            if(!res.ok) throw Error("Não conseguiu buscar");
            return res.json();
        })
        .then(data => {
            setDevices(data); 
            // console.log("painelcontrole.js useEffect getUserdevicesAPI then then ", data);
        })
        .catch(err => {
            console.log("painelcontrole.js useEffect getUserdevicesAPI catch ", err);
        });
        //Busca os devices deste usuário
    }, []);

    return (
        <div className="portal-home-container">
            <div className="portal-home-header-container">
                <div className="portal-home-tittle-container">
                    <div className="tittle">Bem vindo de volta, {user && user.attributes.name}.</div>
                    <Botao handleOnClick={handleOnClickLogout} estilo={{width: "100px", height: "50px"}}>Sair</Botao>
                </div>
                <div className="portal-home-subtittle">Selecione abaixo a opçao desejada:</div>
            </div>
            <div className="portal-home-options-container">
                <Botao handleOnClick={() => navigate("/portal/mapas")} estilo={estiloBotoes}>Gerenciamento de Mapas</Botao>
                <Botao handleOnClick={() => navigate("/portal/trabalhos")} estilo={estiloBotoes}>Ver trabalhos</Botao>
                <Botao handleOnClick={() => navigate("/portal/implementos")} estilo={estiloBotoes}>Ver implementos</Botao>
                <Botao handleOnClick={() => navigate("/portal/veiculos")} estilo={estiloBotoes}>Ver veiculos</Botao>
            </div>
        </div>
    )
}

export default PortalHome
